import { useState } from "react";

export const useFilters = (intialFilters = {}) => {
  const [params, setParams] = useState(intialFilters);

  const setFilters = (filterBy, values) =>
    setParams((params) => ({
      ...params,
      [`filter[${filterBy}]`]: values?.join(","),
    }));

  return [params, setFilters];
};
